import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=d15646c4&scoped=true&"
import script from "./VButton.vue?vue&type=script&lang=js&"
export * from "./VButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15646c4",
  null
  
)

export default component.exports